import Form from './form/form';

const loadDynamicConf = (loadedCallback: () => void) => {
	const origin: string = document.location.origin.replace('localhost', 'integ-config');
	const scriptTag: HTMLScriptElement = document.createElement('script');
	scriptTag.src = `${origin}/common/dynamicconf`;
	scriptTag.addEventListener('load', loadedCallback);
	scriptTag.addEventListener('error', loadedCallback);

	document.body.appendChild(scriptTag);
};

const initRegForm = () => {
	const container: NodeListOf<HTMLFormElement> = document.querySelectorAll('.psg-reg-form');
	container.forEach((form: HTMLFormElement) => {
		new Form(form);
	});
};

const checkDynamicConf = () => {
	if (!window.dynamicConf) {
		loadDynamicConf(initRegForm);
	} else {
		initRegForm();
	}
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	checkDynamicConf();
} else {
	document.addEventListener('DOMContentLoaded', () => checkDynamicConf());
}
